export var ALL_SEVERITIES = ['INFO', 'ERROR'];
export var SEVERITY_COLORS = {
    INFO: '#1890ff',
    ERROR: '#ff4d4f',
};
export var TIME_RANGE_PRESETS = [
    { label: 'Last 5 minutes', value: '5m', duration: 5 * 60 * 1000 },
    { label: 'Last 10 minutes', value: '10m', duration: 10 * 60 * 1000 },
    { label: 'Last 15 minutes', value: '15m', duration: 15 * 60 * 1000 },
    { label: 'Last 30 minutes', value: '30m', duration: 30 * 60 * 1000 },
    { label: 'Last 1 hour', value: '1h', duration: 60 * 60 * 1000 },
    { label: 'Last 3 hours', value: '3h', duration: 3 * 60 * 60 * 1000 },
    { label: 'Last 6 hours', value: '6h', duration: 6 * 60 * 60 * 1000 },
    { label: 'Last 12 hours', value: '12h', duration: 12 * 60 * 60 * 1000 },
    { label: 'Last 1 day', value: '1d', duration: 24 * 60 * 60 * 1000 },
    { label: 'Last 2 days', value: '2d', duration: 2 * 24 * 60 * 60 * 1000 },
    { label: 'Last 3 days', value: '3d', duration: 3 * 24 * 60 * 60 * 1000 },
    { label: 'Last 5 days', value: '5d', duration: 5 * 24 * 60 * 60 * 1000 },
    { label: 'Last 7 days', value: '7d', duration: 7 * 24 * 60 * 60 * 1000 },
    { label: 'Last 10 days', value: '10d', duration: 10 * 24 * 60 * 60 * 1000 },
];
